import OverlayScrollBar from 'overlayscrollbars'

import log from 'salvo-lite/log'

class OverlayScrollbars {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._scrollBar = null
        this._options = {
            maxWidth: 99999999,
            scrollbarOptions: {
                scrollbars: {
                    visibility: 'auto',
                    dragScrolling: true
                }
            },
            ...JSON.parse(elem.getAttribute('data-overlay-scrollbars') || '{}')
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        document.addEventListener('DOMContentLoaded', () => {
            if (window.innerWidth < this._options.maxWidth) {
                this._scrollBar = new OverlayScrollBar(this._elem, this._options.scrollbarOptions)
            }
        })

        window.addEventListener('resize', () => this._resize())
    }

    _resize () {
        if (window.innerWidth < this._options.maxWidth) {
            this._scrollBar = new OverlayScrollBar(this._elem, this._options.scrollbarOptions)
        } else {
            this._scrollBar.destroy()
        }
    }
}

export default OverlayScrollbars



// WEBPACK FOOTER //
// ./src/resources/scripts/components/OverlayScrollbars.js